import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/vercel/path0/src/components/auth/ForgotPasswordForm.tsx");
